export const FAMILY_PACKAGE_PERSON_COUNT = 4
